module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.1-239.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.1.md
// module id = 683
// module chunks = 288